export default "__VITE_ASSET__CULAOX05__"